'use client'
import styled from 'styled-components'
import { CSSProperties } from 'react'

export default function CheckBox(props: {
  checked: boolean
  onChange?: (checked: boolean) => void
  className?: string
  style?: CSSProperties
}) {
  return (
    <CheckBoxWrapper
      style={props.style}
      checked={!!props.checked}
      className={props.className}
      onClick={() => props.onChange && props.onChange(!props.checked)}
    />
  )
}

const CheckBoxWrapper = styled.span<{ checked: boolean }>`
  display: inline-block;
  width: 18px;
  height: 18px;
  border-radius: 2px;
  border: 1px solid ${(props) => (props.checked ? '#F5D802' : '#555454')};
  position: relative;
  cursor: pointer;
  transition: all 0.2s linear;
  &::before {
    content: '';
    width: 8px;
    height: 8px;
    border-radius: 2px;
    position: absolute;
    left: 4px;
    top: 4px;
    background: ${(props) => (props.checked ? '#F5D802' : 'transparent')};
    transition: all 0.2s linear;
  }
`
